import React, { useEffect, useState } from "react";
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Form,
	Row,
} from "reactstrap";
import InputElement, {
	CurrencyInput,
	IntegerInput,
	SelectorElement,
} from "../features/forms/components/InputElement";
import { LoanPeriod } from "../constants/Constants";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import dayjs from "dayjs";
import { createNewAutoPay } from "../api/AutopayApi";
import { failAlert, saveSuccessAlert } from "../utils/alertUtils";

const SetupAutoPay = ({
	account,
	paymentMethods,
	autoPays,
	editAutoPays,
	toggle,
}) => {
	const daysInPeriod = LoanPeriod[account.period].daysInPeriod;
	const start = dayjs(account.nextDueDate);
	const end = dayjs(account.finalDueDate);
	const diffDays = end.diff(start, "day", true);
	const [loanPeriod, setLoanPeriod] = useState(account.period);
	const [paymentMethod, setPaymentMethod] = useState(0);
	const [amount, setAmount] = useState(account.regularPayment);
	const [firstDueDate, setFirstDueDate] = useState(account.nextDueDate);
	const [term, setTerm] = useState(0);
	const [tokenId, setTokenId] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const schema = yup.object().shape({});
	const methods = useForm({
		resolver: yupResolver(schema),
	});
	console.log(paymentMethods);
	const setupPayments = () => {
		if (!tokenId || tokenId === "") {
			failAlert("Must select payment method...");
			return;
		}
		setIsLoading(true);
		const newAutoPay = {
			locationId: account.locationID,
			accountRecNum: account.id,
			tokenId: tokenId,

			amount: amount,
			label: "Loan",
			firstDeliveryDate: firstDueDate,
			frequency: loanPeriod,
			numOfPayments: term,

			source: "Digitzs",
			projectType: "PMP-BHPH-2",
			lastExecutionDate: null,
			totalExecutedTimes: 0,

			createdOn: dayjs().format("YYYY-MM-DD"),
			accountId: account.id,
			accountNumber: account.accountNumber,

			active: true,
		};
		createNewAutoPay(newAutoPay).then(
			(res) => {
				editAutoPays([...autoPays, res.data.content]);
				setIsLoading(false);
				saveSuccessAlert("Successfully created AutoPay!");
				toggle();
			},
			(err) => {
				if (!err.isGeneralError) {
					showApiError(err, retrieveFailAlert);
				}
				setIsLoading(false);
			}
		);
	};
	useEffect(() => {
		setTerm(Math.ceil(diffDays / daysInPeriod) + 1);
		// eslint-disable-next-line
	}, []);

	return (
		<div className="col-lg-12 mx-auto">
			<Form>
				<Card>
					<CardHeader>
						<CardTitle tag="h3">Setup Auto Pay</CardTitle>
					</CardHeader>
					<CardBody>
						<Row>
							<SelectorElement
								disableValidation
								colSize="col-xl-3"
								name="paymentMethod"
								label="Payment Method"
								value={paymentMethod}
								options={[
									{ label: "Select Payment Method", value: "" },
									...(paymentMethods || []).map((method) => ({
										value: method.tokenId,
										label:
											method.tokenType === "ACH" || method.tokenType === "bank"
												? `${
														method.bank.accountType
												  }  ••••${method.bank.accountNumber.slice(-4)}`
												: `${
														method.card.type
												  }  ••••${method.card.cardNumber.slice(-4)}`,
									})),
								]}
								onChange={(e) => {
									setTokenId(e.target.value);
									setPaymentMethod(e.target.value);
								}}
							/>
							<CurrencyInput
								disableValidation
								value={amount}
								onChange={setAmount}
								name="amount"
								label="Amount"
								type="number"
								colSize="col-xl-3"
							/>
							<SelectorElement
								disableValidation
								colSize="col-xl-3"
								name="loanPeriod"
								label="Period"
								value={loanPeriod}
								options={[
									{ label: "WEEKLY", value: 0 },
									{ label: "BIWEEKLY", value: 1 },
									{ label: "SEMIMONTHLY", value: 2 },
									{ label: "MONTHLY", value: 3 },
								]}
								onChange={(e) => {
									setLoanPeriod(Number(e.target.value));
								}}
							/>
							<InputElement
								disableValidation
								type="date"
								name="firstDueDate"
								label="Start Date"
								value={firstDueDate}
								onChange={(e) => setFirstDueDate(e.target.value)}
								colSize="col-xl-3"
							/>
							<IntegerInput
								disableValidation
								value={term}
								onChange={(e) => setTerm(e)}
								name="numberOfPayments"
								label="Number of Payments"
								type="number"
								colSize="col-xl-3"
							/>
						</Row>
						<Button
							color="primary"
							onClick={methods.handleSubmit(setupPayments)}
							disabled={isLoading}
						>
							Save Setup Payments
						</Button>
					</CardBody>
				</Card>
			</Form>
		</div>
	);
};
export default SetupAutoPay;
